import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76a4dc5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdf-wrap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "page-tool" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-minus fa-xl",
  style: {"color":"#ffffff"}
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "page-tool-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-plus fa-xl",
  style: {"color":"#ffffff"}
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-rotate-right fa-xl",
  style: {"color":"#ffffff"}
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-tool-item" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa-solid fa-xmark fa-xl",
    style: {"color":"#ffffff"}
  })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-tool-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page-tool-item" }, "Drag to move")
], -1))
const _hoisted_15 = { class: "page-tool-right" }
const _hoisted_16 = { class: "page-tool-item" }
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-download",
  style: {"color":"#ffffff"}
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]

import { ref, computed, onMounted, watch, nextTick } from "vue";
import {
  getImageUrl,
  getImageUrlWithToken,
} from "@/core/plugins/ProcessImageLink";
import {
  FileFormatTypes,
  getContentTypeFromMedia,
} from "@/core/types/FileFormatTypes";
import VuePdfEmbed from "vue-pdf-embed";
import { createLoadingTask } from "vue3-pdfjs";
import interact from "interactjs";
import ImageWithToken from "@/components/ImageWithToken.vue";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserFileDocModal',
  setup(__props, { expose: __expose }) {

const src = ref("");
const showImageModal = ref(false);
const media = ref<any>(null);

const contentType = ref<FileFormatTypes>(FileFormatTypes.JPEG);

const initStateValue = {
  x: 0,
  y: 0,
  page: 1,
  scale: 1,
  rotate: 0,
  numPages: 0,
};

const state = ref({ ...initStateValue });
const isLoading = ref(true);
const show = async (_media: any) => {
  showImageModal.value = true;
  isLoading.value = true;
  state.value = { ...initStateValue };
  media.value = _media;
  contentType.value = getContentTypeFromMedia(_media);
  src.value = await TenantGlobalService.getImageUrlWithToken(
    getImageUrl(_media.guid)
  );

  if (contentType.value === FileFormatTypes.PDF) {
    const pdfLoadingTask = createLoadingTask(src.value);
    pdfLoadingTask.promise.then((pdf: { numPages: number }) => {
      state.value.numPages = pdf.numPages;
    });
  }
  await nextTick();
  isLoading.value = false;
};

const hide = () => {
  showImageModal.value = false;
  nextTick().then(() => (isLoading.value = true));
};

const transform = computed(
  () =>
    `transform:
          translate(${state.value.x}px, ${state.value.y}px)
          scale(${state.value.scale})
          rotate(${state.value.rotate}deg)
          !important;`
);

const prevPage = () => state.value.page > 1 && (state.value.page -= 1);
const nextPage = () =>
  state.value.page < state.value.numPages && (state.value.page += 1);

const pageZoomOut = () => state.value.scale < 2 && (state.value.scale += 0.1);
const pageZoomIn = () => state.value.scale > 0.5 && (state.value.scale -= 0.1);

const rotateRight = () =>
  (state.value.rotate = (state.value.rotate + 90) % 360);

const registerDragAction = () =>
  interact(".content-embedded").draggable({
    listeners: {
      move(event) {
        let target = event.target;
        let x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
        let y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;
        state.value.x = x;
        state.value.y = y;

        target.setAttribute("data-x", x);
        target.setAttribute("data-y", y);
      },
    },
  });

onMounted(() => {
  registerDragAction();
});

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (showImageModal.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "showImageModalBackDrop",
            onClick: hide
          }, [
            _createElementVNode("div", {
              class: "pdf-preview",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                (!isLoading.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (
                [
                  _unref(FileFormatTypes).JPEG,
                  _unref(FileFormatTypes).JPG,
                  _unref(FileFormatTypes).PNG,
                ].includes(contentType.value)
              )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "content-embedded",
                            style: _normalizeStyle(transform.value)
                          }, [
                            _createElementVNode("img", {
                              src: src.value,
                              style: {"width":"800px"}
                            }, null, 8, _hoisted_2)
                          ], 4))
                        : _createCommentVNode("", true),
                      ([_unref(FileFormatTypes).PDF].includes(contentType.value))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                            style: _normalizeStyle(transform.value),
                            class: "content-embedded"
                          }, [
                            _createVNode(_unref(VuePdfEmbed), {
                              source: src.value,
                              page: state.value.page
                            }, null, 8, ["source", "page"])
                          ], 4))
                        : _createCommentVNode("", true),
                      ([_unref(FileFormatTypes).HTML].includes(contentType.value))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "content-embedded",
                            innerHTML: media.value?.content,
                            style: _normalizeStyle(transform.value)
                          }, null, 12, _hoisted_3))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "page-tool-item",
                  onClick: pageZoomIn
                }, _hoisted_6),
                ([_unref(FileFormatTypes).PDF].includes(contentType.value))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", {
                        class: "page-tool-item",
                        onClick: prevPage
                      }, "Prev"),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(state.value.page) + "/" + _toDisplayString(state.value.numPages), 1),
                      _createElementVNode("div", {
                        class: "page-tool-item",
                        onClick: nextPage
                      }, "Next")
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "page-tool-item",
                  onClick: pageZoomOut
                }, _hoisted_9),
                _createElementVNode("div", {
                  class: "page-tool-item",
                  onClick: rotateRight
                }, _hoisted_11)
              ]),
              _createElementVNode("div", {
                class: "page-tool-top-right",
                onClick: hide
              }, _hoisted_13),
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("a", {
                    href: src.value,
                    target: "_blank"
                  }, _hoisted_19, 8, _hoisted_17)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})